import { render, staticRenderFns } from "./quickMenu.vue?vue&type=template&id=0c30844d&scoped=true&"
import script from "./quickMenu.vue?vue&type=script&lang=js&"
export * from "./quickMenu.vue?vue&type=script&lang=js&"
import style0 from "./quickMenu.vue?vue&type=style&index=0&id=0c30844d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c30844d",
  null
  
)

export default component.exports